import { atomWithKey as atom } from "./atomWithKey";
import { ICmsContentData } from "../Types/Index";

export const contentDetailAtom = atom<ICmsContentData>({
  key: "contentDetailAtom",
  default: {} as ICmsContentData,
});